import type { LandingContent } from '../content';
import { Reveal } from '../components/Reveal';
import { SectionContainer } from '../components/SectionContainer';
import type { TrackingContext } from '../types';
import { trackCtaClick } from '../../utils/ctaTracking';
import { buildAppUrl } from '../../utils/appUrl';

type ReadyToBeginSectionProps = {
  content: LandingContent['readyToBegin'];
  tracking: TrackingContext;
};

export function ReadyToBeginSection({ content, tracking }: ReadyToBeginSectionProps) {
  const destination = buildAppUrl(tracking.registerUrl);

  return (
    <section className="bg-white py-20 text-white sm:py-24 lg:py-[108px]">
      <div className="relative mx-2 overflow-hidden rounded-[8px] bg-[#0A111C] py-20 sm:py-24 lg:py-[108px]">
        <img
          src="/landing/ready-to-begin-bg.png"
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,17,28,0.06)_0%,rgba(10,17,28,0.12)_100%)]" aria-hidden="true" />

        <SectionContainer className="relative z-10">
          <Reveal variant="up">
            <h2 className="text-center font-pangaia text-[40px] font-bold leading-[1.02] tracking-[-0.03em] text-white sm:text-[56px]">
              {content.title}
            </h2>
          </Reveal>

          <Reveal delay={100} variant="up" className="mx-auto mt-10 max-w-[475px]">
            <div className="rounded-[8px] bg-white px-8 py-9 text-[#1C1C1E] shadow-[0_32px_80px_rgba(25,15,8,0.16)] sm:px-10 sm:py-10">
              <p className="font-pangram text-[16px] font-semibold leading-[24px]">{content.label}</p>
              <p className="mt-6 font-pangaia text-[48px] font-bold leading-[56px] tracking-[-0.04em] sm:text-[56px]">
                {content.price}
              </p>
              <a
                href={destination}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackCtaClick({
                    placement: 'ready_to_begin',
                    language: tracking.language,
                    destination,
                    hasAnalyticsConsent: tracking.hasAnalyticsConsent,
                  })
                }
                className="landing-cta-interactive mt-10 flex w-full items-center justify-between rounded-[80px] bg-[#1C1C1E] py-4 pl-6 pr-3 font-pangram text-[16px] font-semibold leading-[24px] text-white shadow-[0_14px_32px_rgba(7,10,18,0.16)] hover:bg-[#171a24] hover:shadow-[0_20px_42px_rgba(7,10,18,0.22)]"
              >
                <span>{content.cta}</span>
                <span className="landing-cta-dot h-3 w-3 rounded-full bg-[#6195FF]" aria-hidden="true" />
              </a>
            </div>
          </Reveal>
        </SectionContainer>
      </div>
    </section>
  );
}
